import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/dream-energy/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_h100 smartid_banner "
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#fff" }}>Muirfield Website Development</h1>
            <p style={{ color: "#fff" }}>
              Today, technology is the key to turning strategies into
              sustainable returns. The real estate investment industry thrives
              on the flow, analysis, and interpretation of information and
              technology that gives it the edge and competitive advantage.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
